import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ALAIN_I18N_TOKEN, I18nPipe } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { I18NService } from 'src/app/core/i18n/i18n.service';
import { HttpService } from 'src/app/http/http.service';
import { TestIdDirective } from 'src/app/shared/directives/test-id.directive';
import { ConstantUtil } from 'src/app/util/constant.util';

@Component({
  selector: 'app-tools',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NzButtonModule,
    NzFormModule,
    NzIconModule,
    NzInputModule,
    NzTabsModule,
    I18nPipe,
    TestIdDirective
  ],
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.less']
})
export class ToolsComponent {
  private readonly fb = inject(FormBuilder);
  private readonly clipboard = inject(Clipboard);
  private readonly message = inject(NzMessageService);
  private readonly http = inject(HttpService);
  private readonly i18n = inject<I18NService>(ALAIN_I18N_TOKEN);
  readonly urlForm = this.fb.nonNullable.group({ url: ['', [Validators.required, Validators.pattern(/^https?:\/\/.+/i)]] });
  shortUrl = '';
  generating = false;

  generateShortUrl(): void {
    if (this.urlForm.invalid) {
      this.urlForm.controls.url.markAsTouched();
      return;
    }
    this.generating = true;
    const source = this.urlForm.controls.url.value.trim();
    this.http.post(ConstantUtil.JOB_SHORT_LINK_V1_CREATE, { longLink: source }).subscribe({
      next: (res: any) => {
        this.shortUrl = typeof res?.data === 'string' ? res.data : '';
        if (!this.shortUrl) this.message.error(res?.msg ?? this.i18n.fanyi('tools.error.empty-response'));
        this.generating = false;
      },
      error: () => {
        this.generating = false;
        this.message.error(this.i18n.fanyi('tools.error.generate-failed'));
      }
    });
  }

  copyShortUrl(): void {
    if (!this.shortUrl) return;
    this.clipboard.copy(this.shortUrl);
    this.message.success(this.i18n.fanyi('tools.copy-success'));
  }
}
